export const OtherPopupRecord = {
  arco_trigger: false
};